"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Machineryrepairtrust() {
  const {
    ref: headerRef,
    isVisible: headerVisible
  } = useRevealOnScroll<HTMLDivElement>();
  const {
    ref: closingRef,
    isVisible: closingVisible
  } = useRevealOnScroll<HTMLDivElement>();
  const disciplines = [{
    numeral: "I",
    name: "Site Survey",
    description: "Our team visits your property to assess the terrain, soil quality, and drainage needs, ensuring every design is built on a solid foundation.",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701933/img/landscaping_survey.webp",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701933/img/landscaping_survey.webp-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701933/img/landscaping_survey.webp-wvc-sizes",
    alt: "Landscaper measuring garden dimensions with tools",
    align: "left"
  }, {
    numeral: "II",
    name: "Hardscaping",
    description: "We construct durable patios and driveways using premium stone and block paving, designed to withstand the Scottish climate for years.",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701933/img/landscaping_paving.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701933/img/landscaping_paving.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701933/img/landscaping_paving.png-wvc-sizes",
    alt: "Professional laying stone patio in a garden",
    align: "right"
  }, {
    numeral: "III",
    name: "Fencing",
    description: "Secure your perimeter with our bespoke fencing solutions. We use pressure-treated timber for maximum longevity and aesthetic appeal.",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701933/img/landscaping_fencing.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701933/img/landscaping_fencing.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701933/img/landscaping_fencing.png-wvc-sizes",
    alt: "New wooden fence installation in a residential garden",
    align: "left"
  }, {
    numeral: "IV",
    name: "Planting",
    description: "We select native shrubs and perennials that thrive in Glasgow’s environment, creating vibrant, low-maintenance garden borders.",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701933/img/landscaping_planting.webp",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701933/img/landscaping_planting.webp-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701933/img/landscaping_planting.webp-wvc-sizes",
    alt: "Gardener planting flowers in a fresh garden bed",
    align: "right"
  }, {
    numeral: "V",
    name: "Garden Design",
    description: "Our designers create custom layouts that maximize your outdoor space, blending functionality with natural beauty for every client.",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701933/img/landscaping_design.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701933/img/landscaping_design.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701933/img/landscaping_design.png-wvc-sizes",
    alt: "Landscape architect reviewing garden blueprints",
    align: "left"
  }, {
    numeral: "VI",
    name: "Maintenance",
    description: "We offer seasonal care packages to keep your garden pristine, from lawn mowing to hedge trimming and general site upkeep.",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701933/img/landscaping_care.webp",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701933/img/landscaping_care.webp-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701933/img/landscaping_care.webp-wvc-sizes",
    alt: "Gardener trimming hedges with professional tools",
    align: "right"
  }];
  return;
}